import { get } from 'utils/lodash'
import { isPriceTypeDollar } from 'utils/service'
import { getWorkOrderData, getInvoiceLineData } from 'data/work-order/workOrderSelectors'

export const getFees = workOrder => {
  const { draftFees, invoiceLine } = getWorkOrderData({ workOrder })
  const { invoiceLineId, invoiceLineItemId } = getInvoiceLineData({ invoiceLine })

  if (invoiceLineId) {
    const newFeeTax = get(invoiceLine, 'invoiceLineItem[0].invoiceFeeTaxCharges', [])
    return newFeeTax.map(fee => ({ ...fee, invoiceLineItemId }))
  }
  return draftFees
}

export const getFeeAndCharges = fees => get(fees, 'feeAndCharges', []).filter(fee => fee?.feeName && isPriceTypeDollar(fee?.valueType))

export const getFeesMapById = fees => {
  const newFeesMapById = {}
  fees.forEach(item => {
    newFeesMapById[item.id] = item
  })
  return newFeesMapById
}
